<script type="text/babel">
  import Base from './BaseMultidimentionalChart.vue'

  export default Base.extend({
    name: "LineChart",
    methods: {
      getChartType: function () {
        return "line";
      }
    }
  })
</script>



// WEBPACK FOOTER //
// LineChart.vue?81ae8c4a